<template>
  <section class="homeWorkContent">
    <h4 :title="moduleInfo.moduleName" v-if="resourceList != ''">{{moduleInfo.moduleName}}</h4>
    <div class="mdlContent">
      
      <div v-for="(item,index) in selectedTextNumArr" :key="index">
        <div class="main" @click="increment($event, item, item.resourceType)">
          <span class="noChoose" :class="{'choose': item.isChecked}"></span>
          <span v-if="item.isPublished" class="publishedIcon">布置过</span>
          <span class="stitle" :title="item.resourceName">{{item.resourceName}}</span>
          <span class="write"  @click.stop="goDetail(item,index)" v-if="item.isChecked">{{item.chooseText}}</span>
        </div>
        <chooseText v-if="(moduleInfo.moduleId == 10 || moduleInfo.moduleId == 15 || moduleInfo.moduleId == 30 || moduleInfo.moduleId == 124 || moduleInfo.moduleId == 127 || moduleInfo.moduleId == 66) && item.isChecked" :moduleId="moduleInfo.moduleId" :item="item" :readTime='item.refLong' :key="index" :serviceId="serviceId" :packageId="packageId" :readtimes="item.readtimes" :speekingtype='item.speekingtype' :cId='cId' :index="index" @changeParams="changeParams">
        </chooseText>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import chooseText from "./../chooseText/chooseText.vue";
import fetch from "./../../fetch";
import { formatDataToMinutes } from "./../../filter";
import { red_url } from "./../../config.js"
export default {
  props: [
    "resourceName",
    "sIndex",
    "resourceList",
    "serviceId",
    "packageId",
    "cId",
    "moduleInfo",
    "publishedBooks",
    "checkedResource"
  ],
  components: {
    chooseText
  },
  data() {
    return {
      ResType_DanCiGenDu: "a7527f97-14e6-44ef-bf73-3039033f128e",
      ResType_Xuanzeduanluo: "992a5055-e9d0-453f-ab40-666b4d7030bb",
      ResType_BaoTingXie: "3ac07125-31ac-11e5-a511-782bcb066f05",
      parentVersion_Id: "",
      version_Id: "",
      selectModules: [],
      selectedTextNumArr: [],
      isChecked: false,
      userTimes: 0
    };
  },
  created() {
    this.$nextTick(() => {
      this.addKey();
    });
  },
  watch: {
    resourceList(val) {
      this.addKey();
    }
  },
  methods: {
    ...mapGetters(["getUser"]),
    addKey() {
      const _this = this;
      this.selectedTextNumArr = this.resourceList;

      this.selectedTextNumArr.forEach((item, i) => {
        this.selectedTextNumArr[i].isShow = false;
        if (this.moduleInfo.moduleId == 10 || this.moduleInfo.moduleId == 127 || this.moduleInfo.moduleId == 30) {
          //同步跟读
          if (item.resourceType == this.ResType_DanCiGenDu || item.resourceType == this.ResType_BaoTingXie) {
            this.selectedTextNumArr[i].chooseText = "选择单词";
          } else if (item.resourceType == this.ResType_Xuanzeduanluo) {
            this.selectedTextNumArr[i].chooseText = "选择段落";
          }
        } else if (this.moduleInfo.moduleId == 15 || this.moduleInfo.moduleId == 124) {
          this.selectedTextNumArr[i].chooseText = "选择大题";
        } else {
           this.selectedTextNumArr[i].chooseText = '预览'
        }
      });

      this.getPublished();
    },
    getPublished() {
      // console.log(this.publishedBooks, '++++++', this.resourceList, this.cId * 1)
      this.resourceList.map(stitem => {
        stitem.isPublished = false;
        this.publishedBooks.map(item => {
          if (item.cId == this.cId * 1) {
            item.subjectList.map(sItem => {
              if (sItem.resourceType == stitem.resourceType && sItem.resourceName == stitem.resourceName && sItem.versionId == stitem.versionId) {
                stitem.isPublished = true
              } else if (sItem.resourceName == stitem.resourceName) {
                  stitem.isPublished = true
              }
            })
          }
        });
        return stitem
      });
      this.selectedTextNumArr = this.resourceList;
    },
    increment(e, item, resourceType) {
      item.isChecked = !item.isChecked;
      let params = {
        isChecked: item.isChecked,
        versionId: item.versionId,
        parentVersionId: item.parentVersionId,
        change: true,
        moduleId: this.moduleInfo.moduleId,
        resourceType,
        requirementContent: {
          readtimes: 1,
          speekingtype: 1
        },
        time: 0,
        refLong: item.refLong,
        resourceName: item.resourceName
      };
      this.getUseTimes(params);
    },
    changeParams(res) {
      // let params = {
      //   isChecked: true,
      //   versionId: res.versionId,
      //   change: false,
      //   moduleId: this.moduleInfo.moduleId,
      //   resourceType: res.resourceType,
      //   parentVersionId: res.parentVersionId,
      //   requirementContent: res.requirementContent
      // };
      let changeData = {
        itemCount: res.item.itemCount,
        defAnswerTime: res.item.defAnswerTime,
        bigItemCount: res.item.bigItemCount,
        sentenceCount: res.item.sentenceCount
      }
      this.reBackData(res.item, changeData)
      // this.getUseTimes(params);
    },
    getUseTimes(res) {
      let params = {
        moduleId: res.moduleId,
        versionId: res.versionId,
        parentVersionId: res.parentVersionId,
        resourceType: res.resourceType
      };
      fetch.getAllCount(params).then(result => {
        if (!result) {
          return false;
        }
        let data = result.data;
        this.reBackData(res, data);
      });
    },
    reBackData (res, data) {
      if (res.resourceType === "992a5055-e9d0-453f-ab40-666b4d7030bb" ) {
        res.refLong = data.refAnswerTime || formatDataToMinutes(data.sentenceCount * data.defAnswerTime * res.requirementContent.readtimes);
      } else if (res.resourceType === "a7527f97-14e6-44ef-bf73-3039033f128e" || res.resourceType === "3ac07125-31ac-11e5-a511-782bcb066f05") {
        res.refLong = data.refAnswerTime || formatDataToMinutes(data.itemCount * data.defAnswerTime * res.requirementContent.readtimes);
      } else {
        res.refLong = data.refAnswerTime || formatDataToMinutes(data.defAnswerTime * data.itemCount);
      }
      res.itemCount = data.itemCount; // 题目数量
      res.bigItemCount = data.bigItemCount || 0; // 题目数量
      res.sentenceCount = data.sentenceCount || 0;
      res.defAnswerTime = data.defAnswerTime;
      res.refScore = data.refScore || 100;
      if (res.time) {
        res.refLong = 0;
      }
      this.$emit("increment", res);
    },
    // 跳转
    goDetail(item, index) {
      if (!item.isChecked) {
        this.$toast("请选择布置内容！", "error");
        return false;
      }
      const moduleId = this.moduleInfo.moduleId;
      let url = window.location.href;
      url = url.split('&isFirst=1')[0] + '&isFirst=1'
      let http = "/exam/#/";
      let userdata = this.getUser();
      let params =
        "?parentVersionId=" +
        this.resourceList[index].parentVersionId +
        "&versionId=" +
        this.resourceList[index].versionId +
        "&resourceType=" +
        this.resourceList[index].resourceType +
        "&moduleId=" +
        this.moduleInfo.moduleId +
        "&checkedResource=" +
        item.checkedResource +
        "&accessToken=" +
        userdata.accessToken +
        "&clientId=" +
        userdata.clientId +
        "&redirectUrl=" +
        url;
      if (moduleId == 10 || moduleId == 30) {
        //单词跟读
        if (this.resourceList[index].resourceType == this.ResType_DanCiGenDu || this.resourceList[index].resourceType == this.ResType_BaoTingXie) {
          window.location.href = http + "selectDanci" + params;
          //选择段落
        } else if (
          this.resourceList[index].resourceType == this.ResType_Xuanzeduanluo
        ) {
          window.location.href = http + "selectJuzi" + params;
        }
      } else if (moduleId == 124 || moduleId == 15) {
        // 听说模考
        window.location.href = http + "selectExam" + params;
      } else if (moduleId == 66) {
        // 互动教程
        window.location.href = http + "selectInteract" + params;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// homeWorkContent.vue?7d64f304